import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import routes from '../routes';
import { Maybe } from '../types';
import { useAuth } from './Authentication';
import { useEngineer } from './EngineerProvider';
import LoadingPage from './Loading/Page';

export default function PrivateRoute({ children, ...rest }: any) {
  const { isSignedIn } = useAuth();
  const { engineer, fetching } = useEngineer();
  if (fetching) return <LoadingPage />;
  let redirect: Maybe<string> = null;
  if (!isSignedIn) {
    redirect = routes.signIn;
  } else if (!engineer) {
    redirect = routes.welcome.root;
  }
  return (
    <Route
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      render={({ location }) => (
        redirect ? (
          <Redirect
            to={{
              pathname: redirect,
              state: { from: location },
            }}
          />
        ) : (
          children
        )
      )}
    />
  );
}
